import { TextField } from "@mui/material";
import { styled } from "@mui/system";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React, { useEffect, useState } from "react";

import { SearchDate } from "./DashboardInfo.style";

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "green",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "red",
    },
    "&:hover fieldset": {
      borderColor: "yellow",
    },
    "&.Mui-focused fieldset": {
      borderColor: "green",
    },
  },
});

const DateRangeFilter = ({
  column: { filterValue, setFilter },
  preFilteredRows,
  id,
}) => {
  const [startDate, setStartDate] = useState(filterValue?.startDate ?? "");
  const [endDate, setEndDate] = useState(filterValue?.endDate ?? "");

  const newFilter = { startDate, endDate };
  useEffect(() => {
    if (endDate.length > 0 && endDate !== " ") {
      setFilter(newFilter, id);
    }

    // };
  }, [endDate, startDate]);

  const handleRegChange = (date) => {
    const dateObj = new Date(date);
    const dateStr = dateObj.toLocaleDateString("en-CA");
    setStartDate(dateStr);
  };

  const handleRegChange1 = (newValue) => {
    const dateObj = new Date(newValue);
    const dateStr = dateObj.toLocaleDateString("en-CA");
    setEndDate(dateStr);
  };

  return (
    <SearchDate>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginTop: "8px",
        }}
      >
        <div>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              inputFormat="dd MMM yyyy"
              value={startDate}
              maxDate={new Date()}
              onChange={handleRegChange}
              renderInput={(params) => (
                <CssTextField
                  type="date"
                  sx={{ width: "90%" }}
                  focused
                  size="small"
                  {...params}
                  label="Form Date"
                />
              )}
            />
          </LocalizationProvider>
        </div>

        <div>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              inputFormat="dd MMM yyyy"
              value={endDate}
              maxDate={new Date()}
              onChange={handleRegChange1}
              renderInput={(params) => (
                <CssTextField
                  type="date"
                  sx={{ width: "90%" }}
                  focused
                  size="small"
                  {...params}
                  label="To Date"
                />
              )}
            />
          </LocalizationProvider>
        </div>
      </div>
    </SearchDate>
  );
};

export default DateRangeFilter;
